import { Component, OnInit, forwardRef, OnDestroy, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
import { takeUntil, tap } from 'rxjs/operators';
@Component({
  template: `
    <input  type="text"
      class="form-control"
      (dateTimeChange)="onDateChange($event)"
      [owlDateTimeTrigger]="dt"
      [owlDateTime]="dt"
      [ngModel]="date"
      />
    <owl-date-time [pickerType]="pickerType" #dt></owl-date-time>
  `,
  styles: [``],
  selector: 'app-date-picker',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true
    }
  ]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor, OnDestroy {
  date: Date = new Date();
  // cast to avoir TS error, but the property exist
  format = (moment as any).HTML5_FMT.DATETIME_LOCAL_SECONDS;
  componentDestroyed$ = new Subject();

  @Input('pickerType') pickerType: string = 'both';

  constructor(private dateTimeAdapter: DateTimeAdapter<any>, private translateService: TranslateService) {}

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  onChange = (date: String) => {};

  registerOnTouched(fn: any) {}

  get value() {
    return this.date;
  }

  writeValue(date: string) {
    this.date = new Date(Date.parse(date));
    this.onChange(moment(this.date).format(this.format));
  }

  onDateChange(ev) {
    this.writeValue(ev.value);
  }

  ngOnInit() {
    this.updateLang();
    const source$ = this.translateService.onLangChange;

    source$.pipe(takeUntil(this.componentDestroyed$), tap(() => this.updateLang())).subscribe();
  }

  updateLang() {
    const lang = this.translateService.store.currentLang || this.translateService.store.defaultLang;
    this.dateTimeAdapter.setLocale(lang.substring(0, 2));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/date-picker/date-picker.component.ts